module.exports = "    ___   _____ ______________   ____\r\n   /   | / ___// ____/  _/  _/  / __ \\____ _________  _____\r\n  / /| | \\__ \\/ /    / / / /   / /_/ / __ `/ ___/ _ \\/ ___/\r\n / ___ |___/ / /____/ /_/ /   / _, _/ /_/ / /__/  __/ /\r\n/_/  |_/____/\\____/___/___/  /_/ |_|\\__,_/\\___/\\___/_/"


//////////////////
// WEBPACK FOOTER
// ./src/res/logo.txt
// module id = 70
// module chunks = 0